import React, {useState, useEffect, useContext} from 'react'
import styled from 'styled-components';
import UserContext from '../../context/context'
import { Link } from 'react-router-dom';
// import { Editor } from 'react-draft-wysiwyg';
// import 'react-draft-wysiwyg/dist/react-draft-wysiwyg.css';
// import { EditorState } from 'draft-js';
import { EditorState, convertToRaw, convertFromRaw } from 'draft-js';
// convertToRaw로 변환시켜준 원시 JS 구조를 HTML로 변환.
import draftToHtml from 'draftjs-to-html';
import { history } from '../../_helpers';
import { render } from 'react-dom';


function QurationSingle() {
  const [quration, setQuration] = useState()
  const [state, actions] = useContext(UserContext);

  let user = JSON.parse(String(localStorage.getItem('user')))
  let email = String(localStorage.getItem('email'))
  let header = {}
  if(user){
    header = {Authorization: `JWT ${user.token}`}
  } else{
    header = {}
  }

  const [title, setTitle] = useState()
  const [contentCom, setContentCom] = useState()
  const [contentComSub, setContentComSub] = useState()

  const [tempComment, setTempComment] = useState()
  const [comments, setComments] = useState()
  const [commentOf, setCommentOf] = useState()

  // const editorToHtml = draftToHtml(convertToRaw(editorState.getCurrentContent()));
  let current_id = history.location.pathname.split('/')[3]
  const [editorToHtml, setEditorToHtml] = useState(EditorState.createEmpty())
  
  const [renderer, setRenderer] = useState(false)

  const [isOpen, setIsOpen] = useState()
  const [ changed, setChanged] = useState(false)

  function fetchCommentPost(){
    
    fetch(state.awslink + "/api/comment/", {
      method: 'POST',
      headers: header,
      body:JSON.stringify({
        "id": parseInt(current_id),
        "content": contentCom,
      })
    })
    .then(response => {response.json();})
    .then(json=>{
      console.log(json)
      setContentCom();
      setRenderer(!renderer)
    })
  }

  function fetchCommentOfPost(comId){
    
    fetch(state.awslink + "/api/commentof/", {
      method: 'POST',
      headers: header,
      body:JSON.stringify({
        "id": parseInt(current_id),
        "comId": comId,
        "content": contentComSub,
      })
    })
    .then(response => {response.json();})
    .then(json=>{
      console.log(json)
      setRenderer(!renderer)
    })
  }

  function fetchCommentLike(id){
    fetch(state.awslink + "/api/commentlike/?id=" + id, {
      method: 'GET',
      headers: header,
    })
    .then(response => response.json())
    .then(json=>{
      console.log(json)
      
      setRenderer(!renderer)
    })
  }

  function keyDown(e){  
    console.log(e)
    if (e.key === 'Enter' && !e.shiftKey) { 
      if(contentCom){  
        e.preventDefault();    
        fetchCommentPost(); 
        setContentCom();
        e.target.value=""
      }
    }
  }

  function keyDownSub(e, comId){  
    // console.log(e)
    if (e.key === 'Enter' && !e.shiftKey) { 
      if(contentComSub){  
        e.preventDefault();    
        fetchCommentOfPost(comId); 
        setContentComSub();
        e.target.value=""
      }
    }
  }

  function handleOpen(item){
    let temp_bool = isOpen.filter(sub=>sub.id===item.id)[0].value
    
    isOpen.filter(sub=>sub.id===item.id)[0].value = !temp_bool
    
    setIsOpen(isOpen)
    setChanged(!changed)
  }


  useEffect(()=>{
    console.log("EFFECT")
    async function fetchQurationGet(){
      fetch(state.awslink + "/api/quration/?id=" + current_id, {
      method: 'GET',
      // headers: header,
      })
      .then(response => response.json())
      .then(json=>{
        console.log(json)
        let parsed = EditorState.createWithContent(convertFromRaw(JSON.parse(json.content))) 

        setEditorToHtml(draftToHtml(convertToRaw(parsed.getCurrentContent())))
        setQuration(json)
      }
      )
    }

    async function fetchCommentGet(){
      fetch(state.awslink + "/api/comment/?id=" + current_id, {
      method: 'GET',
      // headers: header,
      })
      .then(response => response.json())
      .then(json=>{
        console.log(json)
        
        // setComments(oldArray => [...oldArray, json])
        

        if(isOpen){
          if(isOpen.length !== json.length){
            console.log("NEWWW")
            let temp_commentOf = []
            json.map((item, index)=>{
              temp_commentOf.push({id: item.id, value: false})
            })
            setIsOpen(temp_commentOf)
          }
        }
        else{
          let temp_commentOf = []
            json.map((item, index)=>{
              temp_commentOf.push({id: item.id, value: false})
            })
          setIsOpen(temp_commentOf)
          
        }
        setComments(json)

        
        
      }
      )
    }

    async function fetchCommentOfGet(){
      fetch(state.awslink + "/api/commentof/?id=" + current_id, {
      method: 'GET',
      // headers: header,
      })
      .then(response => response.json())
      .then(json=>{
        console.log(json)
        
        // setComments(oldArray => [...oldArray, json])
        setCommentOf(json)
        
      }
      )
    }
    
    if(!quration)fetchQurationGet();
    fetchCommentGet();
    fetchCommentOfGet();
    

  }, [renderer, changed])

  // console.log(comments)
  // console.log(draftToHtml(convertToRaw(editorToHtml.getCurrentContent())))
  // console.log(quration)
  // console.log(email)

  // console.log(contentCom)
  // console.log(commentOf)
  console.log(isOpen)

  return(
    <Wrapper>
      <MidWrapper>
        {quration?
          <>
            <HeaderWrapper>
              <h1>
                {quration.title}
              </h1>
              
              <div className={"qu-add"}>
                {quration.created.split('T')[0]}
              </div>

              {user && quration.user.email === email ?
                <Link to={'/quration/edit/' + quration.id}>수정하기</Link>
              :null}

              <img 
                src = {quration.photolink ? quration.photolink + "?dummy=123": "dummy"} 
                onError={(e)=> {
                  e.target.src = state.noimage
                }}
              />
              

            </HeaderWrapper>

            <ContentWrapper>
              <div dangerouslySetInnerHTML={{__html: editorToHtml}}/>  
            </ContentWrapper>

            

            
          </>
        :null  }
        

        <CommentWrapper>
          {/* {quration && tempComment?
            <div className={"comment"}>
              <div className={"comment-profile"}>
                <header style={{backgroundImage: `url(${state.s3link}/images/${email}/quration_${quration.title}.png)`}}></header>
                <div>{email}</div>
                <div>방금</div>
              </div>
              <div className={"comment-body"}>{tempComment}</div>
              <div className={"comment-like"}>
                <div>Like 0</div>
                <div>댓글</div>
              </div>
            </div>
          :null} */}
          
          {quration && comments?
            comments.length?
              <>
                {comments.map((item, index)=>{
                  return(
                    <div className={"comment"}>
                      <div className={"comment-profile"}>
                        {item.user ? 
                          <img  
                            src = {item.user.profilelink ? item.user.profilelink + "?dummy=123": "dummy"} 
                            onError={(e)=> {
                              e.target.src = state.noimage
                            }}
                          />:null
                        }
                        
                        <div>{item.user.email}</div>
                        <div>{item.created.split('T')[0]} {item.created.split('T')[1].split('.')[0]}</div>
                      </div>
                      
                      <div className={"comment-body"}>{item.content}</div>
                      
                      <div className={"comment-like"}>
                        <div onClick={()=>fetchCommentLike(item.id)}>Like {item.like.length}</div>
                        <div onClick={()=>handleOpen(item)}>댓글</div>
                      </div>
                      
                      {user && isOpen && isOpen.length === comments.length ? isOpen.filter(sub=>sub.id === item.id)[0]["value"] ?
                        <div className={"comment-comment"}>
                          {commentOf && commentOf.map((sub, index)=>{
                            if(sub.comment === item.id)
                            return(
                              <div>
                                {sub.content}
                              </div>
                            )
                          })}
                          <textarea onKeyDown={(e)=>keyDownSub(e, item.id)} value={contentComSub} onChange={(e)=> {setContentComSub(e.target.value)}}/>
                        </div>
                      :null : null}
                      
                    </div>
                  )
                })}

              
              </>
            :null
          :null}
          
          {quration && user ?
          <div className="comment-write">
            {/* Image from profile edit needed */}
            <img  
              src={"https://qurator-01.s3.amazonaws.com/media/images/" + {email} + "/profile.png?dummy=123"}
              
              onError={(e)=> {
                e.target.src = state.noimage
              }}
            />
            <div>
                {/* <form onSubmit={(e)=>{fetchCommentPost(); setContentCom(); setTempComment(contentCom)}}> */}
                <textarea onKeyDown={(e)=>keyDown(e)} value={contentCom} onChange={(e)=> {setContentCom(e.target.value)}}/>
                
                
                {/* </form> */}
                
            </div>
              {/* <button type={"submit"}
                onClick={(e)=>{fetchCommentPost(); setContentCom(); setTempComment(contentCom)}}
                >SEND</button> */}
            
          </div>
          :null}
        </CommentWrapper>
      </MidWrapper>
    </Wrapper>   
  )
}

export default QurationSingle;

const Wrapper = styled.div`
  width: 100%;
  min-height: calc(100vh - 45px);
  margin-top: 45px;
  display: block;
  position: relative;
  background-color: white;
`

const MidWrapper = styled.div`
  max-width: 1060px;
  width: 90%;
  display: block;
  margin: 0 auto;
  /* background-color: whitesmoke; */
`

const HeaderWrapper = styled.div`
  display: block;
  width: 100%;
  margin: 0;
  margin-bottom: 20px;
  max-height: 60vh;

  h1{
    padding-top: 50px;
  }
  >div{
    text-align: right;
    margin-bottom: 10px;
  }
  img{
    height: 40vh;
    background-position-x:50%;
    background-position-y:50%;
    background-size: cover;
  }
  a{
    display: block;
    text-align: right;
  }
`

const ContentWrapper = styled.div`
  display: block;
  margin-bottom: 20px;
  >div{
    box-sizing: border-box;
    text-align: left;
    padding: 20px;
    
  }
`

const CommentWrapper = styled.div`
  display: block;
  margin-bottom: 20px;
  box-sizing: border-box;
  /* text-align: left; */
  padding: 20px;
  
  .comment{
    display: block;
    margin-bottom: 10px;
    .comment-profile{
      display: block;
      text-align: left;
      >img{
        display: inline-block;
        width: 40px;
        height: 40px;
        background-position-x:50%;
        background-position-y:50%;
        background-size: cover; 
        vertical-align: top;
        border-radius: 50px;
      }
      >div{

        :last-child{
          font-size: 0.8rem;
          opacity: .8;
        }
        display: inline-flex;
        justify-content: flex-start;
        align-items: flex-start;
        /* height: 40px; */
        margin-left: 20px;
      }
    }
    .comment-body{
      display: block;
      box-sizing: border-box;
      padding-left: 60px;
      text-align: left;
      margin-bottom: 10px;
    }

    .comment-like{
      display: block;
      box-sizing: border-box;
      padding-left: 60px;
      text-align: left;
      margin-bottom: 10px;
      
      font-size: 0.8rem;
      opacity: .8;

      >div{
        display: inline-block;
        margin-right: 10px;
        cursor: pointer;
      }
    }
    .comment-comment{
      display: block;
      box-sizing: border-box;
      padding-left: 80px;
      text-align: left;
      margin-bottom: 10px;
      textarea{
        width: calc(100% - 40px);
        height: 32px;
        resize: none;
      }
    }    
  }

  .comment-write{
    display: block;
    text-align: left;
    margin-top: 20px;
    margin-bottom: 20px;

    >img{
      display: inline-block;
      width: 40px;
      height: 40px;
      background-position-x:50%;
      background-position-y:50%;
      background-size: cover; 
      vertical-align: top;
      border-radius: 50px;
    }

    >div{
      display: inline-block;
      vertical-align: top;
      margin-left: 20px;
      height: 80px;

      :nth-child(2){
        width: calc(100% - 80px);
        /* background-color: green; */
      }
      :last-child{
        /* background-color: green; */
      }

      textarea{
        height: 80px;
        width: 100%;
        resize: none;
        box-sizing: border-box;
        border: .5px solid rgba(0,0,0,0.2);
        border-radius: 5px;
      }
      button{
        width: 80px;
        height: 80px;
        background-color: rgba(253,134,18,0.6);
        color: white;
        font-weight: bold;
        font-size: 1.1rem;
        border: none;
        border-radius: 5px;
      }
    }
  }
  
`
